import * as Common from '@/agiles/common';

export class AuditLog extends Common.ObjectBase {
  constructor() {
    super('AuditoLog');
  }
  public id: number;
  public auditName: string;
  public auditNo: string;
  public userId: string;
  public timeStamp: Date;
  public type: auditTypes;
  public auditItem: string;

  public get auditItems(): AuditItem[] {
    const result = new Array<AuditItem>();
    if (this.auditItem != null) {
      (JSON.parse(this.auditItem) as Array<any>).forEach(source => {
        const target = new AuditItem();
        Object.assign(target, source);
        result.push(target);
      });
    }
    return result;
  }
}

export class AuditItem {
  public path: string;
  public before: string;
  public after: string;
}

export enum auditTypes {
  added,
  modified,
  deleted,
}

export class AuditLogQuery extends Common.LoadQuery {
  constructor() {
    super('AuditLogQuery', AuditLog);
    this.sort = 'timeStamp';
    this.isDescending = true;
  }
  public auditName: string = '';
  public auditType: Common.auditTypes = null;
  public auditNo: string = ''; //完全一致検索
  public auditNoPartial:string = ''; //部分一致検索
  public editorMode: boolean = false;
  public loadAll:boolean = true;

  public timestampFrom: Date = null;
  public timestampTo: Date = null;
  public userId: string = '';
}

export class AuditLogExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super("",loadQuery);
    this.className = "AuditLogExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
  }
}